<template>
  <div class="minfooter">
    <div class="contact">
      <div class="phone">电话 : 400-8877-685</div>
      <div class="email">邮箱 : sykj@ytsg.com</div>
      <div class="contact">地址 : 四川省成都市高新区天府大道北段1700号E3-904、906号</div>
    </div>
    <div class="footerContent">
      <div class="about" @click="showAbout">关于我们</div>
      <div class="right">Copyright © 2016-2018 四川四原科技有限公司 版权所有 <a  style="color:#989898" href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备17005013号-1</a>
      </div>
      <div class="code_small">APP二维码 <img class="code" src="../assets/images/code_big.png" alt="APP二维码"></div>
    </div>
  </div>
</template>
<script>
  import {store} from '../store/store.js';
  import {ajaxUtil} from '../common/AjaxUtil.js';
  import {api} from '../common/config.js';
  import {StorageUtil, LocalStorageUtil} from '../common/Auth.js';
  export default {
    name: 'Footer',
    data() {
      return {
        readerNumber: 0,
        type: store.webType,
      }
    },
    beforeMount() {
      store.footer = this;
    },
    mounted() {
      this.getVisits()
    },
    methods: {
      showAbout: function () {
        this.$router.push('/about')
      },
      getVisits:function () {
        if (this.type===1){
          var libcode=this.$route.query.hallCode;
          if (store.func.getUserObj()==null){
            if (StorageUtil.getObject(libcode)) {
              this.readerNumber=StorageUtil.getObject(libcode);
              return;
            }else {
              this.getCount(libcode,null);
            }
          }else {
            var idCard=store.func.getUserObj().idCard;
            if (StorageUtil.getObject(libcode+idCard)) {
              this.readerNumber=StorageUtil.getObject(libcode);
              return;
            }else {
              this.getCount(libcode,idCard);
            }
          }
        }
      },
      getCount(libcode,idCard){
        var url = api.readNumber.visitNum;
        var submitData = {
          hallCode: libcode
        };
        ajaxUtil.ajaxJson(url, submitData, "PUT", ((data) => {
          this.readerNumber=  data.visitNum;
          if (idCard==null){
            StorageUtil.storeObject(libcode,this.readerNumber);
          }else {
            StorageUtil.storeObject(libcode+idCard,this.readerNumber);
          }
        }), (data) => {
        }, this);
      }
    }
  }
</script>
<style lang="sass" scoped>
%mr30
  margin-right: 30px

%line
  background: url("../assets/images/line.png") right center no-repeat
.minfooter
  position: absolute
  bottom: 0
  width: 100%
  height: 80px
  font-size: 0
  text-align: center
  background: rgb(41, 41, 41)
  padding: 14px 0 0 0px
  box-sizing: border-box
  .contact div
    display: inline-block
    font-size: 12px
    color: #989898
    line-height: 35px
  .phone
    @extend %mr30
    padding-right: 30px
    @extend %line
  .email
    @extend %mr30
    padding-right: 30px
    @extend %line
  .footerContent div
    display: inline-block
    font-size: 12px
    line-height: 20px
    color: #989898
  
  .about
    margin-right: 12px
    padding-right: 10px
    background: url("../assets/images/line.png") right no-repeat
    cursor: pointer
  .right
    margin-right: 62px
  .code_small
    position: relative
    padding-left: 29px
    background: url("../assets/images/code_small.png") left no-repeat
    cursor: pointer
    .code
      display: none
      position: absolute
      left: 50%
      bottom: 60px
      margin-left: -73px
      box-shadow: 0 0 10px rgba(0,0,0,0.2)
    &:hover .code
      display: block


</style>
